@if (model.data) {
@switch (!!model.data.isBanner) {
<!--
    BANNER
    -->
@case (true) {
<href [link]="model.data.banner_url || ''">
    <div class="pos-relative overflow-hidden height-100 b-radius-4 bg-col-1 flex flex-column">
        <div class="ratio-41-28 ratio-57-23-s ratio-57-23-m overflow-hidden">
            <shell></shell>
            <product-alt-image [mainImage]="getImage()"
                               class="fill"
                               [ratio]="client.sizeId < 2 ? 'ratio-57-23' : 'ratio-41-28'"
                               [altImage]="getAlternativeImage()"
                               [altText]="model.data.name || ''"></product-alt-image>
        </div>
        <!-- banner copies -->
        <div class="col-w"
             [sizeClass]="'SM: p-a-2 p-t-5 p-b-5, XL: flex-grow flex flex-column flex-justify-center w-10 p-l'">
            <p [sizeClass]="'XL:h3, SM:s2'">{{model.name}}</p>
            <div class="_devider m-t-2"></div>
            <p [sizeClass]="'XL:p1, SM:c1'"
               class="m-t-2">{{model.data.banner_subtitle || ''}}</p>
            @if (model.data.banner_url) {
            @if(client.isX || client.isL) {
            <button [buttonStyle]
                    [style.width]="'fit-content'"
                    class="m-t-5"><span>{{'Apply now' | translate}}</span></button>
            } @else {
            <button [inlineButton]
                    class="m-t-2 col-6 s2"><span>{{'Apply now' | translate}}</span></button>
            }
            }
        </div>
    </div>
</href>
}
<!--
    REGULAR PRODUCT
    -->
@case (false) {
<div class="b-radius-4 bg-col-w height-100 p-b-2 p-t-2-s p-t-2-m flex-column gap8">

    <!-- MOBILE -->
    @if(client.isS || client.isM) {
    <div class="flex-grow">
        <div class="flex gap8 p-l-2 p-r-2">
            <div class="_imgWrapMobile noShrink">
                <ng-container *ngTemplateOutlet="productImageTmpl"></ng-container>
            </div>

            <!-- brand image -->
            <div class="flex flex-column gap4 flex-justify-between flex-grow">
                <ng-container *ngTemplateOutlet="nameSkuTmpl"></ng-container>
                <ng-container *ngTemplateOutlet="brandAndReviewsTmpl"></ng-container>
            </div>
        </div>
    </div>
    }
    <!-- DESKTOP -->
    @else {
    <!-- image -->
    <ng-container *ngTemplateOutlet="productImageTmpl"></ng-container>

    <!-- brand image and reviews -->
    <div class="p-l-2 p-r-2 flex flex-column gap4 flex-grow">
        <ng-container *ngTemplateOutlet="brandAndReviewsTmpl"></ng-container>
        <ng-container *ngTemplateOutlet="nameSkuTmpl"></ng-container>
    </div>
    }

    <div class="flex flex-column gap8 p-l-2 p-l-1-m p-l-1-s p-r-2 p-r-1-m p-r-1-s p-b-1-s p-b-1-m"
         [ngClass]="isProPriceMode ? 'bg-col-1 m-l-2 m-r-2 b-radius-4' : 'gap8'">
        @if(client.isX || client.isL) {
        <!-- promo bar (desktop)-->
        <product-promo-bar [product]="model"
                           (promoBarChange)="handlePromoBarChange($event)"></product-promo-bar>
        }


        <!-- price and qty -->
        <ng-container *ngTemplateOutlet="priceQtyTmpl"></ng-container>

        @if(client.isS || client.isM) {
        <!-- promo bar (mobile) -->
        <product-promo-bar [product]="model"
                           (promoBarChange)="handlePromoBarChange($event)"></product-promo-bar>

        }
    </div>

    <!-- buttons -->
    <ng-container *ngTemplateOutlet="buttonsTmpl"></ng-container>

    <!-- wishlist -->
    <ng-container *ngTemplateOutlet="wishlistToggleTmpl"></ng-container>
</div>

<!-- TEMPLATE: image -->
<ng-template #productImageTmpl>
    <href class="ratio-1-1 pos-relative w-12 overflow-hidden b-radius-4"
          [link]="model.data.url || ''"
          [gtmTrackProductClick]="gtmProductClick"
          [klevuTrackClick]="klevuSearchTrackClick"
          [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
          [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData">
        <shell></shell>
        <product-alt-image [ratio]="1"
                           [mainImage]="getImage()"
                           [altImage]="getAlternativeImage()"
                           [altText]="model.data.name || ''"></product-alt-image>

        <product-image-label class="_imageLabel"
                             [product]="model"></product-image-label>

    </href>
</ng-template>

<!-- TEMPLATE: brand and reviews -->
<ng-template #brandAndReviewsTmpl>
    <div class="flex flex-justify-between _brandReviewsWrap flex flex-middle flex-justify-between">
        <reviews-io-rating [theme]="'gold'"
                           [product]="model"></reviews-io-rating>

        @if(model.brandImage) {
        <img [routerLink]="('/browse/brands/' + model.brandUrl) | lowercase"
             [ratio]="1"
             class="_brandImage"
             [dfImage]="model.brandImage"
             [attr.alt]="model.brandLabel || ''">
        }
    </div>
</ng-template>



<!-- TEMPLATE: wishlist toggle -->
<ng-template #wishlistToggleTmpl>
    @if (wishlistItem) {
    <product-wishlist-toggle [productId]="model.id"
                             [item]="wishlistItem"
                             class="pos-absolute top-4 right-3"></product-wishlist-toggle>
    }
</ng-template>

<!-- TEMPLATE: name and sku -->
<ng-template #nameSkuTmpl>
    <!-- name -->
    <href class="col-1"
          [sizeClass]="'SM:c1, XL:p2 _nameClamp'"
          [link]="model.data.url || ''"
          [gtmTrackProductClick]="gtmProductClick"
          [klevuTrackClick]="klevuSearchTrackClick"
          [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
          [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData"
          cy-listingProductName>{{model.data.name}}
        @if (model.data.sku && (client.isS || client.isM)) {
        <span class="col-4">({{model.data.sku}})</span>
        }
    </href>
    @if (model.data.sku && (client.isX || client.isL)) {
    <p class="col-1 c2">{{'Product Code:' | translate}}&nbsp;{{model.data.sku}}
    </p>
    }
</ng-template>

<!-- TEMPLATE: price and qty -->
<ng-template #priceQtyTmpl>
    <div class="flex flex-middle gap8 p-b-2-x p-b-2-l p-t-1-m p-t-1-s">
        <!-- price -->
        <product-price [product]="model"
                       [proPriceMode]="isProPriceMode"
                       [qty]="qty"
                       [ngClass]="isTradeScope ? 'm-t-1' : 'm-t-2 m-t-1-s m-t-1-m'"
                       class="inline-block flex-span-1 noShrink"></product-price>

        @if(!hideButtons){
        <product-qty [model]="qty || null"
                     (qtyChange)="onQtyChange($event)"
                     class="flex-span-1 noShrink"
                     [min]="1"></product-qty>
        }
    </div>
</ng-template>

<!-- TEMPLATE: buttons -->
<ng-template #buttonsTmpl>
    @if(!hideButtons){
    <product-add-to-basket [product]="model"
                           class="m-l-2 m-r-2"
                           [qty]="qty"></product-add-to-basket>
    }
</ng-template>
}
}
}
